// @ts-ignore
export const isMobileApp = () => window.ReactNativeWebView != null;

// @ts-ignore
export const getMobileAppParams = () => isMobileApp() ? window.Flamingo2AppOptions as FlamingoAppParams : undefined;

// @ts-ignore
export const getMobileAppKeyboardShown = () => isMobileApp() ? window.Flamingo2AppKeyboardShown : false;

export const space = {
  appPadding: 16,
  navCollapseWidth: 56,
  navWidth: 244,
  maxWidth: 1620,
  headerHeight: 97,
  headerMobileHeight: 64,
  mobileNavHeight: () => 64 + (getMobileAppParams()?.safeViewBottom ?? 0),
  mobileBottomPadding: () => (getMobileAppParams()?.safeViewBottom ?? 0),
  mobileTopPadding: () => (getMobileAppParams()?.safeViewTop ?? 0)
};